import React, { useState } from 'react'
import ItemSelectableWithStatusAndCheck from '../ItemSelectable/ItemSelectableWithStatusAndCheck'
import infoCloudIcon from '../../assets/icons/info-minicloud-icon.svg';
import { t } from 'i18next';
import AdditionalVehicleInfo from './AdditionalVehicleInfo';
import statusOptions from './statusOptions';
import { getTenantInfoByKey, havePermission } from '../../helpers/helpers';
import { DocumentDueModal } from '../CreateAccess/DocumentDueModal'
import { ContractsDetailModal } from '../CreateAccess/ContractsDetailModal';

const VehicleSelectableCard = ({ vehicle, checked, onChange }) => {

    const [showMoreInfo, setShowMoreInfo] = useState(false);

    const [showDocumentDueModal, setShowDocumentDueModal] = useState(false);

    const [showContractsDetailModal, setShowContractsDetailModal] = useState(false);

    const haveDueDocuments = vehicle.vehicle_status ? vehicle.vehicle_status?.contractor_status === 2 || vehicle.vehicle_status?.vehicle_status === 2 || vehicle.vehicle_status?.vehicle_general_status === 2 : false

    const havePermissionToSeeContractsDetail = havePermission(25);

    const havePermissionToSeeDueDocuments = havePermission(24);

    const contracts = vehicle?.vehicle_status?.contracts;

    return (
        <>
            <AdditionalVehicleInfo
                showModal={showMoreInfo}
                setShowModal={() => setShowMoreInfo(!showMoreInfo)}
                vehicle={vehicle}
                statusLabel={vehicle.vehicle_status ? t(statusOptions[vehicle.vehicle_status.vehicle_general_status].label) : ''}
                statusColor={vehicle.vehicle_status ? statusOptions[vehicle.vehicle_status.vehicle_general_status].color : ''}
            />

            {showDocumentDueModal && (
                <DocumentDueModal
                    showModal={showDocumentDueModal}
                    setShowModal={() => setShowDocumentDueModal(!showDocumentDueModal)}
                    resourceDocumentsDue={vehicle.vehicle_status?.vehicle_due_documents}
                    contractorDocumentsDue={vehicle.vehicle_status?.contractor_due_documents}
                    mainContractorsDocumentsDue={vehicle.vehicle_status?.maincontractors_status}
                />
            )}

            {showContractsDetailModal && (
                <ContractsDetailModal
                    resource='VEH'
                    contracts={contracts}
                    showModal={showContractsDetailModal}
                    setShowModal={() => setShowContractsDetailModal(!showContractsDetailModal)}
                />
            )}

            <ItemSelectableWithStatusAndCheck
                statusLabel={vehicle.vehicle_status ? t(statusOptions[vehicle.vehicle_status.vehicle_general_status].label) : ''}
                statusColor={vehicle.vehicle_status ? statusOptions[vehicle.vehicle_status.vehicle_general_status].color : ''}
                name={`vehicle-${vehicle.vehicle_natural_id}`}
                checked={checked}
                onChange={onChange}
                disabled={getTenantInfoByKey('block_ingress_if_is_not_ok') && vehicle?.vehicle_status?.vehicle_general_status === 2 && vehicle?.vehicle_status?.is_excepted === false}
            >
                <div>
                    <p className='m-0 vehicleName-card'>{vehicle.vehicle_brand} {vehicle.vehicle_model} {vehicle.vehicle_year}</p>
                    <div className="d-flex gap-2">
                        <p className='m-0 vehiclePatent-card'>{vehicle.vehicle_natural_id}</p>
                        {
                            vehicle?.vehicle_status?.is_excepted === true ?
                                <p className='vehiclePatent-card m-0'>{t('EXCEPTED')}</p>
                                :
                                null
                        }
                    </div>
                    <p className='vehiclePatent-card m-0'>{t('CONTRACTOR')}:  <span className='vehicleContractorName-card m-0'>{vehicle.contractor_name ? vehicle.contractor_name : '-'}</span></p>
                </div>
                <div
                    className='pb-1 d-flex align-items-center'
                    type='button'
                    onClick={() => setShowMoreInfo(!showMoreInfo)}
                >
                    <img className='me-1' src={infoCloudIcon} alt="" />
                    <p className='m-0 additional-info-card me-2'>{t('ADDITIONAL_INFO')}</p>
                    {
                        vehicle.is_assigned ?
                            <p className='m-0 assigened-text'>{t('ASSIGNED')}</p>
                            :
                            null
                    }
                </div>
                {(havePermissionToSeeDueDocuments && haveDueDocuments) && (
                    <div
                        type='button'
                        onClick={() => setShowDocumentDueModal(!showDocumentDueModal)}
                    >
                        <span
                            className='blue-text'
                            style={{ fontSize: '.8rem' }}
                        >
                            {t('VIEW_DUE_DOC')}
                        </span>
                    </div>
                )}
                {(havePermissionToSeeContractsDetail) && (
                    <div
                        type='button'
                        onClick={() => setShowContractsDetailModal(!showContractsDetailModal)}
                    >
                        <span
                            className='blue-text'
                            style={{ fontSize: '.8rem' }}
                        >
                            {t('SHOW_CONTRACTS_DETAILS')}
                        </span>
                    </div>
                )}
            </ItemSelectableWithStatusAndCheck>
        </>
    )
}

export default VehicleSelectableCard